const estado = {}

function convert (cadena) {
  return cadena.toLowerCase().replace(/\s/g, '_')
}

estado.install = function (Vue) {
  Vue.filter('estado', (val) => {
    return convert(val)
  })
}

export default estado
